<div class="loader flex-utility align-center justify-center" [ngStyle]="{position: position}">
    <img src="../assets/images/loader.svg" alt="loader">
</div>
